import React from 'react';
export function FooterSection() {
  return <footer className="bg-[#050a1a] py-8 px-4 border-t border-[#1e293b] text-center" data-id="element-44">
      <div className="max-w-4xl mx-auto" data-id="element-45">
        <p className="font-black text-white mb-2 text-xl" data-id="element-46">
          🎹 KIT COMPLETO TECLADO LISTO
        </p>
        <p className="text-gray-500 text-sm mb-4" data-id="element-47">
          © 2026 Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-6 text-sm text-gray-400" data-id="element-48">
          <span className="cursor-pointer hover:text-white transition-colors" data-id="element-49">
            Términos y Condiciones
          </span>
          <span className="cursor-pointer hover:text-white transition-colors" data-id="element-50">
            Políticas de Privacidad
          </span>
        </div>
      </div>
    </footer>;
}